import { clearCache, deleteCacheByPrefix } from '@/lib/indexedDbCache';

// Map derived from prisma/schema.prisma. Each entry: a regex matched against the
// write URL (leading '/' stripped) and the list of GET path prefixes to flush.
// Multiple entries may match; flushes are idempotent.
export const INVALIDATION_MAP: Array<{ match: RegExp; flush: string[] }> = [
  // GeneralDiary hub: list + derived stats + suspects/victims aggregates + filter options + dashboard.
  // Schema: GeneralDiary has many Suspect, Victim, ActAndSection, WeaponDetail,
  // QuestionResponse, GeneralDiaryCaseCategory; owns a Document.
  {
    match: /^general-diaries(\/|$|\?)/,
    flush: [
      'general-diaries',
      'documents',
      'filter-options',
      'v1/dashboard',
      'v1/statics',
      'reports/get-ps-wise-report',
    ],
  },

  // Each notice / bond order owns a Document (Document.crpc129NoticeId etc.).
  { match: /^crpc129-notice(\/|$|\?)/,  flush: ['crpc129-notice', 'documents'] },
  { match: /^bnsl129-notice(\/|$|\?)/,  flush: ['bnsl129-notice', 'documents'] },
  { match: /^crpc-bond-order(\/|$|\?)/, flush: ['crpc-bond-order', 'documents'] },

  // Goonda cluster is independent (GoondaActCase + Evidence + Attachment + StageHistory).
  { match: /^goonda-act-case(\/|$|\?)/, flush: ['goonda-act-case', 'v1/dashboard'] },

  // Reference data. case-category is embedded in GD list payloads, so flush GD too.
  { match: /^case-category(\/|$|\?)/,   flush: ['case-category', 'general-diaries'] },
  { match: /^police-stations(\/|$|\?)/, flush: ['police-stations', 'filter-options'] },
  { match: /^users(\/|$|\?)/,  flush: ['users'] },

  // OCR/text extraction creates a Document.
  { match: /^extract-text(\/|$|\?)/,    flush: ['documents'] },
];

// Endpoints that should fully wipe the cache (session boundary).
const FULL_CLEAR_PATTERNS: RegExp[] = [
  /^users\/login$/,
  /^users\/logout$/,
];

const normalize = (url: string) => url.replace(/^\//, '').split('?')[0];

export async function invalidateForWrite(url: string): Promise<void> {
  try {
    const path = normalize(url);

    if (FULL_CLEAR_PATTERNS.some((re) => re.test(path))) {
      await clearCache();
      return;
    }

    const flushSet = new Set<string>();
    for (const entry of INVALIDATION_MAP) {
      if (entry.match.test(path)) {
        for (const prefix of entry.flush) flushSet.add(prefix);
      }
    }

    await Promise.all([...flushSet].map((p) => deleteCacheByPrefix(p)));
  } catch (err) {
    console.warn('[cacheInvalidation] invalidateForWrite failed', err);
  }
}
